export default __webpack_public_path__ + "static/media/birthday-vibe.82abd39f.webp";